module.exports = __webpack_public_path__ + "static/media/edit.cc85bd6e.svg";